import {
  EApiPersonalityTypes,
  EPersonalityTypes,
} from 'affiny-core/modules/personalityReport/types';
import { IRootState } from 'affiny-core/modules/state';

/* ***** *****  Utils  ***** ***** */

const personalityTypesMapping: Record<
  EApiPersonalityTypes,
  EPersonalityTypes
> = {
  CONVENTIONAL_ROMANTIC: EPersonalityTypes.CHIVALROUS,
  EQUALITY: EPersonalityTypes.EGALITARIAN,
  MODERN_ROMANTIC: EPersonalityTypes.NEO_ROMANTIC,
  TRADITIONAL: EPersonalityTypes.TRADITIONNALIST,
};

/* ***** *****  Type selector  ***** ***** */

export const selectPersonalityType = (state: IRootState) => {
  const type = state.personalityReport?.vision?.attributes.graphes[0]
    .emphasis[0] as EApiPersonalityTypes | undefined;

  return type ? personalityTypesMapping[type] : undefined;
};

/* ***** *****  Graphs selectors  ***** ***** */

export const selectValuesGraphs = (state: IRootState) =>
  state.personalityReport.values?.attributes.graphes ?? [];

export const selectVisionGraphs = (state: IRootState) =>
  state.personalityReport.vision?.attributes.graphes ?? [];

export const selectPersonalityGraphs = (state: IRootState) =>
  state.personalityReport.personality?.attributes.graphes ?? [];

export const selectPersonalityIntroAnalysis = (state: IRootState) =>
  state.personalityReport.personality?.attributes.analysis ?? [];
